module.exports = __webpack_public_path__ + "media/images/aboutus/bg-about-yellow-f277dcc37a2509c53161e3289d7facad.png";